import { useCallback } from 'react';
import { useToast } from './ToastContext';
import Toast from './Toast';
import styles from './ToastContainer.module.scss';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const onClose = useCallback((id: string) => removeToast(id), [removeToast]);
  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          content={toast.content}
          type={toast.type}
          onClose={onClose}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
